export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ऑपरेशन दोहराएँ"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ऑपरेशन इतिहास"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["खाता सूची"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["अज्ञात त्रुटि"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["टोकन सूची"])}
}